module.exports = __webpack_public_path__ + "static/media/corporate-services-img66.593e1e33.jpg";